// extracted by mini-css-extract-plugin
module.exports = {"postCopy":"PostCopy-module__postCopy___3hfg4","versionLabel":"PostCopy-module__versionLabel___1T_r_"};